import React from 'react';
import { Flex } from 'antd';

import userAvatar from '../../../../assets/images/userAvatar.svg';
import emailAvatar from '../../../../assets/images/emailAvatar.svg';

export type EmailMsg = {
  sender: string;
  from: string;
  to: string;
  body: string;
  timestamp: string;
};

type Props = {
  transcript?: EmailMsg[];
  showFull?: boolean;
  onToggleTime?: () => void;
  formatTime?: (iso: string, showFull: boolean) => string;
};

const EmailPreview: React.FC<Props> = ({ transcript = [] }) => {
  return (
    <div className='emailPreview'>
      {(transcript || []).map((msg, index) => {
        const isCompany = msg.sender !== 'AI';

        return (
          <div key={index} className='emailPreview__card'>
            <Flex align='start' className='emailPreview__row'>
              <Flex gap='12px' align='start' className='emailPreview__content'>
                <img
                  src={isCompany ? emailAvatar : userAvatar}
                  width={32}
                  alt='avatar'
                  className='emailPreview__avatar'
                />

                <div className='emailPreview__body'>
                  <p
                    className={`emailPreview__sender ${isCompany ? 'emailPreview__sender--company' : 'emailPreview__sender--user'}`}
                  >
                    {msg.sender}{' '}
                    <span className='emailPreview__from'>{`<${msg.from}>`}</span>
                  </p>

                  <p className='emailPreview__to'>to {msg.to}</p>

                  <p
                    className='emailPreview__message'
                    dangerouslySetInnerHTML={{ __html: msg.body }}
                  />
                </div>
              </Flex>
            </Flex>
          </div>
        );
      })}

      {(transcript?.length ?? 0) === 0 && (
        <p className='emailPreview__empty'>No transcript available</p>
      )}
    </div>
  );
};

export default EmailPreview;
